import script from "./NodataView.vue?vue&type=script&setup=true&lang=js"
export * from "./NodataView.vue?vue&type=script&setup=true&lang=js"

import "./NodataView.vue?vue&type=style&index=0&id=5063ad3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5063ad3e"]])

export default __exports__